import React, { useState, useEffect } from "react";
import CountdownTimer from "./CountdownTimer";
import CompetitionInfo from "./CompetitionInfo";

const PreCompetitionScreen = ({ competitionData, onCompetitionStart, t }) => {
  const [showCountdown, setShowCountdown] = useState(false);

  useEffect(() => {
    // Проверяем, нужно ли показывать таймер (менее 1 часа до начала)
    const timeUntilStart = +new Date(competitionData.started_at) - +new Date();
    const oneHour = 60 * 60 * 1000;

    if (timeUntilStart > 0 && timeUntilStart <= oneHour) {
      setShowCountdown(true);
    }

    // Проверяем каждую секунду, не началось ли соревнование
    const checkInterval = setInterval(() => {
      const now = +new Date();
      const startTime = +new Date(competitionData.started_at);
      
      if (now >= startTime) {
        onCompetitionStart();
      }
    }, 1000);

    return () => clearInterval(checkInterval);
  }, [competitionData.started_at, onCompetitionStart]);

  return (
    <div 
      className="pre-competition-screen"
      style={{
        backgroundImage: competitionData.cover_url 
          ? `url(${competitionData.cover_url})`
          : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="overlay-content">
        <CompetitionInfo competition={competitionData} t={t} />
        
        {!showCountdown && (
          <div className="status-message">
            <h2>{t.competition_not_started}</h2>
          </div>
        )}

        {showCountdown && (
          <div className="countdown-section">
            <h3>{t.starting_soon}</h3>
            <CountdownTimer 
              targetDate={competitionData.started_at}
              t={t.countdown}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PreCompetitionScreen;
